(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_download-link-resmed"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-download-trigger]').forEach(function (link) {
    if (link.dataset.downloadInit === 'true') return;
    link.dataset.downloadInit = 'true';

    link.addEventListener('click', function (e) {
      e.preventDefault();

      var url = link.getAttribute('href');
      var filename = link.getAttribute('data-download-filename');

      fetch(url)
        .then(function (res) { return res.blob(); })
        .then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(blobUrl);
        })
        .catch(function () {
          // Fallback: open in new tab
          window.open(url, '_blank');
        });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["download-button-resmed"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-download-trigger]').forEach(function (link) {
    if (link.dataset.downloadInit === 'true') return;
    link.dataset.downloadInit = 'true';

    link.addEventListener('click', function (e) {
      e.preventDefault();

      var url = link.getAttribute('href');
      var filename = link.getAttribute('data-download-filename');

      fetch(url)
        .then(function (res) { return res.blob(); })
        .then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(blobUrl);
        })
        .catch(function () {
          // Fallback: open in new tab
          window.open(url, '_blank');
        });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
